import React from 'react';
import '../stylesheet/Footer.css';
import '../stylesheet/style.css';
import {
    TbBrandLinkedin,
    TbBrandFacebook,
    TbBrandTwitter,
    TbBrandInstagram,
    TbBrandStackoverflow,
    TbBrandGithub
  } from "react-icons/tb";

export default function Footer() {
        return (
                <footer>
                    <div className="social-container">
                        {/* <p>©<span>Mohamed Sajfan</span></p> */}
                        <a href="https://www.facebook.com/mohamedsajfan" className="facebook social">
                            <TbBrandFacebook/>
                        </a>
                        <a href="https://www.instagram.com/mohamedsajfan/" className="instagram social">
                            <TbBrandInstagram/>
                        </a>
                        <a href="https://twitter.com/mohamedsajfan" className="twitter social">
                            <TbBrandTwitter/>
                        </a>
                        <a href="https://www.linkedin.com/in/mohamedsajfan" className="linkedin social">
                            <TbBrandLinkedin/>
                        </a>
                        <a href="https://stackexchange.com/users/19769283/mohamed-sajfan" className="stackoverflow social">
                            <TbBrandStackoverflow/>
                        </a>
                        <a href="https://github.com/Sajfan" className="github social">
                            <TbBrandGithub/>
                        </a>
                    </div>
                </footer>
        )
}
